var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],ref:"container",attrs:{"title":_vm.text}},[_vm._v(" "+_vm._s(_vm.truncatedText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }